import { Maybe } from "@/domains/common/types";
import { NoteSourceModelData } from "@/store/sources/types";
import { OptimisticSyncUpdate, SyncUpdateValue } from "@/store/sync/types";

export type NoteSourceIndexData = {
  note_id: string;
  source_id: string;
};

export class NoteSourceIndexes {
  private data: SyncUpdateValue<NoteSourceModelData>;

  constructor({
    remoteData,
    optimisticUpdates,
  }: {
    remoteData: Maybe<SyncUpdateValue<NoteSourceModelData>>;
    optimisticUpdates: OptimisticSyncUpdate<NoteSourceModelData>[];
  }) {
    this.data =
      (optimisticUpdates.at(-1)?.value as SyncUpdateValue<NoteSourceModelData>) || remoteData;
  }

  get note_id() {
    return this.data.model_data.note_id;
  }

  get source_id() {
    return this.data.model_data.source_id;
  }

  get indexes(): NoteSourceIndexData {
    return {
      note_id: this.note_id,
      source_id: this.source_id,
    };
  }
}
